import React, { Component } from 'react';
import * as Gserv from '../services/GatewayService';
import { TimelineTwoTone, UndoTwoTone, PrintTwoTone, Settings} from '@material-ui/icons';
import {Paper, Grid, Typography, IconButton, Button, Tooltip} from '@material-ui/core';
import DatasheetView from './DatasheetView';
import ReactToPrint from 'react-to-print';
import Logo from '../assets/360_logo.png';
import ThreeSixtyBlock from './360LeadershipSubBlock';
import moment from 'moment';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';
import FilterBox from './FilterBox';
import Toggle from './Toggle';
// import { cloneElement } from 'react';

export default class ThreeSixtyReport extends Component {
    constructor(props) {
        super(props);
        this.state = {  //Note: designations not reset
            reports_avail: [],
            error: false,
            error_message: '',
            querying: false,
            show_report: false,
            current_record : {},
            report_data: [],
            STEP_CHANGE: [],
            HIGH_P : [],
            OWN : [],
            CUST_EFF : [],
            PROF : [],
            COLLAB : [],
            comments : [],
            overall_ave: 0,
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
            show_all: false,
        };
        
        this.datasheetFieldSpecs = [
            // { field: 'id', headerName: 'Empl. #', width: 90, sortable:false},
            { field: 'report', headerName: 'Report', width: 80, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.showReport(parms)}
                    color='primary' 
                >
                    <TimelineTwoTone/>
                </IconButton>
            )},
            { field: 'name', headerName: 'Assessee', width: 130},
            { field: 'assessee_id', headerName: 'Employee#', width: 130},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'region', headerName: 'Region', width: 110, align:'center',headerAlign:'center'},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125},
            { field: 'assessment_count', headerName: 'Assessments', width: 75, sortable:false, align: 'center'},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 130},
            { field: 'cycle_name', headerName: 'Cycle', width: 350, sortable:false},
        ]
    }

    componentDidMount = (show_all = false) => {
        //async request list of 360 reports available...
        if (this.state.reports_avail.length===0 || this.state.show_all!==show_all){ 
            this.setState({querying:true, reports_avail:[], filtered_assessments_array:[]}); 
            Gserv.sendCommand('query_360_avail',this.props.gwt,{show_all: show_all})
            .then(reports_avail => {
                // console.log('reports_avail :>> ', reports_avail);
                if (reports_avail.error){
                    console.log('error on return from Gserv (query_360_avail) :>> ', reports_avail);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reports_avail.Result!=="Success"&&reports_avail.statusCode!==204){
                    console.log('error on return from Gserv (query_360_avail) :>> ', reports_avail);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {

                    if (this.state.filter_applied){
                        this.setState({querying:false, reports_avail:reports_avail.Records?reports_avail.Records : []});
                        if (!reports_avail.Records) {this.setState({filtered_assessments_array:[]})}
                        this.applyFilter(this.state.filter_obj);
                    } else {
                        this.setState({querying:false, reports_avail:reports_avail.Records?reports_avail.Records : [], filtered_assessments_array:reports_avail.Records?reports_avail.Records : []});
                    }

                }
            }); 
        }
    };

    resetMe = () => {
        this.setState({error: false,error_message:'',show_report:false});
    }    

    showReport = (record) => {
        // console.log('record :>> ', record);
        this.setState({
            current_record:record.row,
            show_report:true,
            querying: true,
            report_data: [],
            comments : [],
            overall_ave: null
        });

        Gserv.sendCommand('query_360_data',this.props.gwt,
        {
            assessee_id: record.row.assessee_id,
            cycle_id: record.row.cycle_id
        })
        .then(report_data => {
            // console.log('report_data :>> ', report_data);
            if (report_data.error){
                console.log('error on return from Gserv (query_360_data) :>> ', report_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (report_data.Result!=="Success"){
                console.log('error on return from Gserv (query_360_data) :>> ', report_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                let STEP_CHANGE = [];
                let HIGH_P = [];
                let OWN = [];
                let CUST_EFF = [];
                let PROF = [];
                let COLLAB = [];
                let comments = [];
                let overall_ave = 0;
                for (var i = 0; i < report_data.Records.length; i++){
                    switch (report_data.Records[i].datapoint_code) {
                        case 'STEP_CHANGE':
                            STEP_CHANGE.push(report_data.Records[i])
                            break;
                        case 'HIGH_PERFORMANCE':
                            HIGH_P.push(report_data.Records[i])
                            break;
                        case 'OWNERSHIP':
                            OWN.push(report_data.Records[i])
                            break;
                        case 'CUST_LED_EFFICIENCY':
                            CUST_EFF.push(report_data.Records[i])
                            break;
                        case 'PROFESSIONALISM':
                            PROF.push(report_data.Records[i])
                            break;
                        case 'COLLABORATION':
                            COLLAB.push(report_data.Records[i])
                            break;
                        case '360_COMMENT':
                            comments.push(report_data.Records[i])
                            break;
                        case 'AVE_360_SCORE':
                            overall_ave+= Number(report_data.Records[i].score)
                            break;
                        default:
                            break;
                    }
                }

                overall_ave = Math.round((overall_ave / this.state.current_record.assessment_count)*1000)/100;

                this.setState({
                    report_data: report_data.Records,
                    STEP_CHANGE: STEP_CHANGE,
                    HIGH_P : HIGH_P,
                    OWN : OWN,
                    CUST_EFF : CUST_EFF,
                    PROF : PROF,
                    COLLAB : COLLAB,
                    comments : comments,
                    querying:false,
                    overall_ave: overall_ave
                });

            }
        }); 

    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_assessments_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_assessments_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '360 Reports ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - Available 360 Reports as at ' + dateStr + '.xlsx');
        }
    }

    handleFilterChange = (filterObj) => {
        // console.log('filterObj :>> ', filterObj);
        if (filterObj.type==='clear'){
            this.setState({filtered_assessments_array : this.state.reports_avail, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.reports_avail.length > 0){
            let temp_array = [];
            switch (filterObj.type) {
                case 'name':
                    for (const record of this.state.reports_avail){
                        if (record.name.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'number':
                    for (const record of this.state.reports_avail){
                        if (record.assessee_id.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
 
                case 'rom':
                    for (const record of this.state.reports_avail){
                        if (record.reports_to_rom.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                default:
                    break;
            }
            this.setState({filtered_assessments_array: temp_array, filter_applied:true});
        }
    }   
    
    handleToggleChange = (e) => {
        // console.log('e :>> ', e);
        // console.log("State show_all: ", this.state.show_all,' e.value: ',e.value);
        switch (e.field) {
            case 'show_all':
                if (e.value !== this.state.show_all){
                    this.setState({show_all:e.value});
                    this.componentDidMount(e.value);
                }
                break;

            default:
                break;
        }
    }

    render() {return(
        <Grid
            container
            direction='column'
            justifyContent='flex-start'
            alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >

            {!this.state.show_report&&
            <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1000
                    }}
                >

                    <Grid
                        container
                        // style={{backgroundColor:'yellow'}}
                        justifyContent='center'
                        alignContent='center'
                    >


                        <Grid item xs={4}>
                            <div style={{display:'flex', justifyContent:'space-evenly', alignItems:"center"}}>
                                <Tooltip title="Export to Excel">
                                <span>
                                <IconButton 
                                    aria-label='Export to Excel'
                                    onClick={this.exportMe}
                                    disabled={this.state.filtered_assessments_array.length===0}
                                >
                                    <ExcelLogo />
                                </IconButton>
                                </span>
                                </Tooltip>
                            </div>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography
                                color='primary'
                                style={{padding:10}}
                            >
                                Available 360 Leadership Assessment Reports
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Grid 
                                container
                                alignItems='center'
                                justifyContent='space-evenly'
                                // style={{backgroundColor:'yellow'}}
                            >
                                <FilterBox
                                    setParentFilter={this.handleFilterChange}
                                    data_populated={this.state.reports_avail.length>0? true : false}
                                    filter_applied={this.state.filter_applied}
                                    filter_obj={this.state.filter_obj}
                                    show_hod_filter={true}
                                    // show_branch_filter={true}
                                    // show_cycle_filter={true}
                                />
                            </Grid>

                            <div style={{paddingLeft:'40px'}}>
                            <Toggle
                                fieldMap={{field: "show_all", headerName: "Include Closed Cycles?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                                editRecord={{show_all: this.state.show_all}}
                                setField={this.handleToggleChange}
                            />
                            </div>

                        </Grid>

                    </Grid>


                    {/* Datagrid goes here */}
                    <DatasheetView 
                        dataset={this.state.filtered_assessments_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={false}
                        edit={false}
                        handleDelete={null}
                        handleEdit={null}
                        loading={this.state.querying}
                        deleteHeaderName={'Delete'}
                        pagesize={15}
                        height={600}
                    />
                </Paper>
            </Grid>}

            {this.state.show_report&&
            <Grid item>
            
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1000,
                        padding:15,
                    }}
                >
                    <Tooltip title="Back"><IconButton aria-label='Back' onClick={()=>this.setState({show_report:false, current_record:{}})}><UndoTwoTone /></IconButton></Tooltip>

                    <Tooltip title="Print or save as .pdf">
                        <span>
                        <ReactToPrint
                            content={() => this.componentRef}
                            bodyClass={'printSpecs'}
                            trigger={() => <IconButton aria-label='Print or save as .pdf'><PrintTwoTone /></IconButton>}
                        />
                        </span>
                    </Tooltip>

                </Paper>

                <div id='Print Delimiter' 
                    ref={(response) => (this.componentRef = response)}
                >        

                    <div
                        style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                        
                    >
                        <Grid container direction='row' justifyContent='space-evenly' alignItems='center'>
                            <img
                                    src={Logo}
                                    alt={'360 Logo'}
                                    height={78}
                                    width={161}
                            />
                            <Grid item>
                                <Typography color='primary' variant='h6'>360 Leadership Assessment Report</Typography>
                                <Typography>For : <b>{this.state.current_record.name}</b> (Empl.# {this.state.current_record.assessee_id}) for cycle <b>{this.state.current_record.cycle_code}</b></Typography>
                                <Typography>{this.state.current_record.job_title} [<b>{this.state.current_record.store_code} {this.state.current_record.region}</b>] Reporting to Manager: <b>{this.state.current_record.reports_to_rom}</b></Typography>
                                <Typography>Generated : {new Date().toDateString()}</Typography>
                                <Typography><b>{this.state.current_record.assessment_count}</b> assessment(s) on file</Typography>
                            </Grid>
                            <Grid item>
                                <Grid container direction='column' justifyContent='center' alignItems='center'> 
                                    <Typography >Overall Average Score:</Typography>
                                    <Typography variant='h6' color='primary'>{this.state.overall_ave}%</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>

                    {this.state.querying&&
                    <Typography
                        style={{marginTop:25}}
                    >
                        <Settings className='icn-spinner' /><br/>
                        Extracting report data...
                    </Typography>}

                    {!this.state.querying&&
                    <Paper
                        elevation={3}
                        style={{
                            // backgroundColor:'blue',
                            width:1000,
                            padding:15
                        }}
                    >

                        <Grid container direction={'row'} justifyContent='space-evenly'>
                            <ThreeSixtyBlock 
                                title={'STEP CHANGE'}
                                data_array={this.state.STEP_CHANGE}
                            />
                            <ThreeSixtyBlock 
                                title={'HIGH PERFORMANCE'}
                                data_array={this.state.HIGH_P}
                            />
                        </Grid>
                        <hr/>
                        <Grid container direction={'row'} justifyContent='space-evenly'>
                            <ThreeSixtyBlock 
                                title={'OWNERSHIP'}
                                data_array={this.state.OWN}
                            />
                            <ThreeSixtyBlock 
                                title={'CUSTOMER-LED EFFICIENCY'}
                                data_array={this.state.CUST_EFF}
                            />
                        </Grid>
                        <hr/>
                        <Grid container direction={'row'} justifyContent='space-evenly'>
                            <ThreeSixtyBlock 
                                title={'PROFESSIONALISM'}
                                data_array={this.state.PROF}
                            />
                            <ThreeSixtyBlock 
                                title={'COLLABORATION'}
                                data_array={this.state.COLLAB}
                            />
                        </Grid>
                    </Paper>}

                    {!this.state.querying&&
                    <Paper
                        elevation={3}
                        style={{
                            // backgroundColor:'blue',
                            width:1000,
                            padding:15,
                        }}
                    >
                        <Grid container direction='column' justifyContent='flex-start' alignItems='flex-start'>
                            <Typography><b>Comments:</b></Typography>
                            {this.state.comments.map(function(item, i){
                                return <Typography key={item.assessment_key}><u>{item.assessment_type}</u> : {item.comment}</Typography>
                            })}
                        </Grid>

                    </Paper>}

                </div>

            </Grid>}

            <Grid item>
                <Typography color='secondary' style={{Width:1000,maxWidth:1000, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    )}
}